import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../../common/layout/notification.service';
import { LayoutService } from '../../../common/layout/layout.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private notificationService: NotificationService,
        private layoutService: LayoutService
    ) {
        this.layoutService.enableFooter();
    }

    ngOnInit(): void {

    }

}
